import React, { useEffect } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Button,
    Badge,
} from "reactstrap"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import {
    setBreadcrumbItems,
    getCustomerInvoices,
} from "../../store/actions"

const InvoicesList = props => {
    document.title = "Factures | CRM Entreprise"

    const breadcrumbItems = [
        { title: "Finances", link: "#" },
        { title: "Factures", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Factures", breadcrumbItems)
        props.getCustomerInvoices()
    }, [])

    const statusColors = {
        'draft': 'secondary',
        'sent': 'info',
        'paid': 'success',
        'partial': 'warning',
        'overdue': 'danger',
        'cancelled': 'dark',
    }

    const statusLabels = {
        'draft': 'Brouillon',
        'sent': 'Envoyée',
        'paid': 'Payée',
        'partial': 'Partielle',
        'overdue': 'Échue',
        'cancelled': 'Annulée',
    }

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('fr-MA', {
            style: 'currency',
            currency: 'MAD'
        }).format(amount)
    }

    return (
        <React.Fragment>
            <div className="container-fluid">
                <Row>
                    <Col className="col-12">
                        <Card>
                            <CardBody>
                                <div className="d-flex align-items-center justify-content-between mb-4">
                                    <CardTitle className="h4 mb-0">Liste des Factures</CardTitle>
                                    <Link to="/finance/invoices/create">
                                        <Button color="success">
                                            <i className="mdi mdi-plus me-1"></i> Nouvelle Facture
                                        </Button>
                                    </Link>
                                </div>

                                <div className="table-responsive">
                                    <table className="table table-centered table-nowrap mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>N° Facture</th>
                                                <th>Client</th>
                                                <th>Date</th>
                                                <th>Échéance</th>
                                                <th>Total</th>
                                                <th>Payé</th>
                                                <th>Solde</th>
                                                <th>Statut</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {props.invoices && props.invoices.data && props.invoices.data.map((invoice, key) => (
                                                <tr key={key}>
                                                    <td>
                                                        <Link to={`/finance/invoices/${invoice.id}`} className="text-primary fw-bold">
                                                            {invoice.invoice_number}
                                                        </Link>
                                                        {invoice.type === 'credit_note' && (
                                                            <div className="mt-1">
                                                                <Badge color="danger">AVOIR</Badge>
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <h5 className="font-size-14 mb-0">
                                                            {invoice.customer?.first_name} {invoice.customer?.last_name}
                                                        </h5>
                                                        <p className="text-muted mb-0">{invoice.customer?.company_name}</p>
                                                    </td>
                                                    <td>{new Date(invoice.invoice_date).toLocaleDateString('fr-FR')}</td>
                                                    <td>{new Date(invoice.due_date).toLocaleDateString('fr-FR')}</td>
                                                    <td className="fw-bold">{formatCurrency(invoice.total)}</td>
                                                    <td className="text-success">{formatCurrency(invoice.paid_amount)}</td>
                                                    <td className={invoice.balance > 0 ? "text-danger fw-bold" : ""}>
                                                        {formatCurrency(invoice.balance)}
                                                    </td>
                                                    <td>
                                                        <Badge color={statusColors[invoice.status]}>
                                                            {statusLabels[invoice.status]}
                                                        </Badge>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex gap-2">
                                                            <Link to={`/finance/invoices/${invoice.id}`}>
                                                                <Button color="primary" size="sm">
                                                                    <i className="mdi mdi-eye"></i>
                                                                </Button>
                                                            </Link>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = state => ({
    invoices: state.Invoices.invoices,
})

export default connect(mapStateToProps, {
    setBreadcrumbItems,
    getCustomerInvoices,
})(InvoicesList)
